import React from "react";
import Cheer from "./cheer/Cheer";
import CheerListTab from "./cheerList/CheerListTab";
import TopCheerersTab from "./topCheers/TopCheerersTab";

export const tabs = [
  {
    name: "Express!",
    content: <Cheer />,
  },
  {
    name: "History",
    content: <CheerListTab />,
  },
  {
    name: "Leaderboard",
    content: <TopCheerersTab />,
  },
];
